import { Spinner } from 'components/ideal-core-ui'
import noop from 'lodash/noop'

import s from './Input.scss'
import cn from 'classnames'

const Input = ({
  style,
  text,
  hasSpellcheck,
  placeholder,
  onChangeCb,
  onEnterCb,
  onBlurCb,
  isDisabled,
  isLoading,
  type,
  name,
  classname,
  cy,
  min,
  maxLength,
  rows
}) => {
  const isTextarea = type === 'textarea'
  const Component = isTextarea ? 'textarea' : 'input'
  const containerClassName = isTextarea ? s.containerTextarea : s.container
  const className = typeof isLoading === 'boolean' ? s.spinnerInput : s.input

  return (
    <div className={containerClassName} style={style}>
      <Component
        className={cn(className, classname)}
        type={type}
        value={text}
        placeholder={placeholder}
        disabled={isDisabled || false}
        spellCheck={hasSpellcheck || isTextarea}
        onChange={onChangeCb}
        onBlur={onBlurCb}
        name={name}
        onKeyPress={event => {
          if (event.key.toLowerCase() === 'enter') {
            onEnterCb()
          }
        }}
        data-cy={cy}
        autoComplete="randomtext"
        min={min}
        maxLength={maxLength}
        rows={rows}
      />
      {isLoading && <Spinner />}
    </div>
  )
}

Input.defaultProps = {
  onEnterCb: noop
}

export default Input
